/* Dynamic pricing from JSON API + monthly/yearly toggle */
(function () {
    var root = document.getElementById("streqo-pricing");
    if (!root) return;

    var inner = root.querySelector(".streqo-pricing__inner");
    var configuredApiUrl = (root.getAttribute("data-api-url") || "").trim();
    var fallbackUrl = (root.getAttribute("data-fallback-url") || "").trim();
    var OVERRIDE_KEY = "streqo-pricing-billing-override";
    var LEGACY_BILLING_KEY = "streqo-pricing-billing";
    var cacheKeyPrefix = "streqo-pricing-cache-v5";
    var cacheTtlMs = 5 * 60 * 1000;

    function resolvePricingFetchUrl() {
        return configuredApiUrl || fallbackUrl || "";
    }

    function trimLower(s) {
        if (s == null || s === "") return "";
        return String(s).trim().toLowerCase();
    }

    /** Server default: billing.default, root defaultBilling, or monthly. */
    function defaultBillingFromJson(json) {
        var raw = null;
        if (json && json.billing && json.billing.default != null) {
            raw = json.billing.default;
        } else if (json && json.defaultBilling != null) {
            raw = json.defaultBilling;
        }
        var n = trimLower(raw);
        if (n === "yearly" || n === "annual" || n === "year") {
            return "yearly";
        }
        if (n === "monthly" || n === "month") {
            return "monthly";
        }
        return "monthly";
    }

    /**
     * User choice after clicking Monthly / Yearly only (OVERRIDE_KEY).
     * Legacy LEGACY_BILLING_KEY is removed so JSON billing.default is not
     * overridden by an old implicit save.
     */
    function getUserBillingOverride() {
        try {
            var o = localStorage.getItem(OVERRIDE_KEY);
            if (o === "yearly" || o === "monthly") {
                return o;
            }
            if (localStorage.getItem(LEGACY_BILLING_KEY) != null) {
                localStorage.removeItem(LEGACY_BILLING_KEY);
            }
        } catch (e) {}
        return null;
    }

    function setUserBillingOverride(b) {
        try {
            localStorage.setItem(OVERRIDE_KEY, b);
        } catch (e) {}
    }

    function textNode(parent, tag, className, content) {
        var el = document.createElement(tag);
        if (className) el.className = className;
        if (content != null && content !== "") el.textContent = content;
        parent.appendChild(el);
        return el;
    }

    function clear(el) {
        while (el.firstChild) el.removeChild(el.firstChild);
    }

    function readCache(storageKey) {
        try {
            var raw = sessionStorage.getItem(storageKey);
            if (!raw) return null;
            var parsed = JSON.parse(raw);
            if (!parsed || !parsed.t || !parsed.data) return null;
            if (Date.now() - parsed.t > cacheTtlMs) return null;
            return parsed.data;
        } catch (e) {
            return null;
        }
    }

    function writeCache(storageKey, data) {
        try {
            sessionStorage.setItem(
                storageKey,
                JSON.stringify({ t: Date.now(), data: data }),
            );
        } catch (e) {}
    }

    function normalizeFeature(item) {
        if (typeof item === "string") {
            return { text: item, included: true };
        }
        if (item && typeof item === "object") {
            var text = item.text != null ? String(item.text) : "";
            var included =
                item.included === false || item.included === "false"
                    ? false
                    : true;
            return { text: text, included: included };
        }
        return { text: "", included: true };
    }

    /** Parens + “coming soon” variants (keep in sync with strip). */
    var COMING_SOON_PAREN_RE =
        /\s*[\(\uff08]\s*coming(?:\s+|[\u2013\u00ad\-])\s*soon\s*[\)\uff09]\s*/gi;

    /**
     * "(coming soon)", fullwidth parens, NBSP, hyphen between words, etc.
     * Ghost ships `built/source.js`; edit here then run `gulp build` in this theme.
     */
    function featureIsComingSoon(text) {
        if (text == null || text === "") return false;
        var t = String(text)
            .replace(/[\u200B-\u200D\uFEFF]/g, "")
            .replace(/\u00a0|\u202f/g, " ");
        COMING_SOON_PAREN_RE.lastIndex = 0;
        return COMING_SOON_PAREN_RE.test(t);
    }

    /** Visible label without the “(coming soon)” suffix (icon still marks it). */
    function featureTextWithoutComingSoon(text) {
        if (text == null || text === "") return "";
        var t = String(text)
            .replace(/[\u200B-\u200D\uFEFF]/g, "")
            .replace(/\u00a0|\u202f/g, " ");
        COMING_SOON_PAREN_RE.lastIndex = 0;
        t = t.replace(COMING_SOON_PAREN_RE, " ").replace(/\s{2,}/g, " ").trim();
        return t;
    }

    function hrefWithBilling(url, billing) {
        if (!url || url === "#") return url;
        if (url.indexOf("mailto:") === 0 || url.indexOf("tel:") === 0) {
            return url;
        }
        try {
            var u = new URL(url, window.location.origin);
            u.searchParams.set("billing", billing);
            return u.toString();
        } catch (e) {
            return url;
        }
    }

    function normalizePromo(raw) {
        if (!raw || typeof raw !== "object") return null;
        var label =
            raw.label != null
                ? String(raw.label)
                : raw.badge != null
                  ? String(raw.badge)
                  : "";
        var endsAt = raw.endsAt != null ? String(raw.endsAt) : "";
        if (raw.active === false) {
            return {
                ring: false,
                label: label,
                endsAt: endsAt,
                endsLine: "",
            };
        }
        if (endsAt) {
            var ms = Date.parse(endsAt);
            if (!isNaN(ms) && ms < Date.now()) {
                return {
                    ring: false,
                    label: label,
                    endsAt: endsAt,
                    endsLine: "",
                };
            }
        }
        var endsLine = "";
        if (endsAt) {
            var d = Date.parse(endsAt);
            if (!isNaN(d)) {
                try {
                    endsLine =
                        "Ends " +
                        new Date(d).toLocaleDateString(undefined, {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                        });
                } catch (e) {
                    endsLine = "";
                }
            }
        }
        return {
            ring: Boolean(label || endsAt),
            label: label,
            endsAt: endsAt,
            endsLine: endsLine,
        };
    }

    function trimStr(s) {
        if (s == null) return "";
        return String(s).trim();
    }

    /** Strip ZWSP / NBSP etc. so “empty” amounts from APIs don’t slip through. */
    function trimPriceAmount(s) {
        if (s == null) return "";
        return String(s)
            .replace(/[\u200B-\u200D\uFEFF]/g, "")
            .replace(/\u00a0|\u202f/g, " ")
            .trim();
    }

    /** True when the main price line should render (not blank / suffix-only). */
    function hasRenderablePriceAmount(amt) {
        var a = trimPriceAmount(amt);
        if (!a) return false;
        var compact = a.replace(/\s+/g, "").toLowerCase();
        if (
            compact === "/year" ||
            compact === "/yr" ||
            compact === "/month" ||
            compact === "/mo" ||
            compact === "/"
        ) {
            return false;
        }
        return true;
    }

    /**
     * When the amount is marketing copy (“Contact us”, “Custom”) with no
     * digits/currency, hide “/ year” etc. so the suffix never appears alone.
     */
    function amountSuggestsBillingSuffix(amt) {
        if (!trimPriceAmount(amt)) return false;
        if (/[0-9]/.test(amt)) return true;
        if (/[€$£¥₹]|\b(?:eur|usd|gbp)\b/i.test(amt)) return true;
        return false;
    }

    function hasDisplayablePrice(tier, billing) {
        var prices = tier.prices;
        if (!prices || typeof prices !== "object") return false;
        var p = billing === "yearly" ? prices.yearly : prices.monthly;
        if (!p || typeof p !== "object") return false;
        return hasRenderablePriceAmount(p.formatted);
    }

    /** True if any billing slot has a real main price (ignores suffix-only rows). */
    function tierRawPricesHaveRenderableAmount(prices) {
        if (!prices || typeof prices !== "object") return false;
        var slots = ["monthly", "yearly", "one_shot"];
        for (var i = 0; i < slots.length; i++) {
            var slot = prices[slots[i]];
            if (
                slot &&
                typeof slot === "object" &&
                hasRenderablePriceAmount(slot.formatted)
            ) {
                return true;
            }
        }
        return false;
    }

    function anyTierHasPricedSlot(tiers) {
        for (var i = 0; i < tiers.length; i++) {
            if (hasDisplayablePrice(tiers[i], "monthly")) return true;
            if (hasDisplayablePrice(tiers[i], "yearly")) return true;
        }
        return false;
    }

    function normalizeTier(t, idx) {
        var prices = t.prices || {};
        var monthly = prices.monthly || {};
        var yearly = prices.yearly || {};
        var hasRealPrice = tierRawPricesHaveRenderableAmount(prices);
        if (!hasRealPrice) {
            monthly = {};
            yearly = {};
        }
        var ySave =
            hasRealPrice && yearly.savingsBadge != null
                ? String(yearly.savingsBadge).trim()
                : "";
        var fmtM = trimPriceAmount(monthly.formatted);
        var fmtY = trimPriceAmount(yearly.formatted);
        return {
            id: t.id != null ? String(t.id) : "tier-" + idx,
            name: t.name != null ? String(t.name) : "Plan",
            description: t.description != null ? String(t.description) : "",
            highlight: Boolean(t.highlight),
            badge: t.badge != null ? String(t.badge) : "",
            promo: normalizePromo(t.promo),
            prices: {
                monthly: {
                    formatted: fmtM,
                    suffix: fmtM
                        ? monthly.suffix != null
                            ? String(monthly.suffix)
                            : "/ month"
                        : "",
                    equivalentFormatted: fmtM
                        ? monthly.equivalentFormatted != null
                            ? String(monthly.equivalentFormatted).trim()
                            : ""
                        : "",
                    equivalentSuffix: fmtM
                        ? monthly.equivalentSuffix != null
                            ? String(monthly.equivalentSuffix)
                            : ""
                        : "",
                },
                yearly: {
                    formatted: fmtY,
                    suffix: fmtY
                        ? yearly.suffix != null
                            ? String(yearly.suffix)
                            : "/ year"
                        : "",
                    equivalentFormatted: fmtY
                        ? yearly.equivalentFormatted != null
                            ? String(yearly.equivalentFormatted).trim()
                            : ""
                        : "",
                    equivalentSuffix: fmtY
                        ? yearly.equivalentSuffix != null
                            ? String(yearly.equivalentSuffix)
                            : "per month, billed yearly"
                        : "",
                    savingsBadge: fmtY ? ySave : "",
                },
            },
            cta: {
                label:
                    t.cta && t.cta.label != null
                        ? String(t.cta.label)
                        : "Choose plan",
                url: t.cta && t.cta.url != null ? String(t.cta.url) : "#",
                style: (function () {
                    var s =
                        t.cta && t.cta.style != null
                            ? trimLower(t.cta.style)
                            : "";
                    if (s === "outline") return "outline";
                    return "primary";
                })(),
            },
            features: Array.isArray(t.features)
                ? t.features.map(normalizeFeature)
                : [],
        };
    }

    function normalizePageCta(raw) {
        if (!raw || typeof raw !== "object") return null;
        var label = raw.label != null ? String(raw.label).trim() : "";
        var url = raw.url != null ? String(raw.url).trim() : "";
        if (!label || !url) return null;
        var s = raw.style != null ? trimLower(raw.style) : "";
        return {
            label: label,
            url: url,
            style: s === "outline" ? "outline" : "primary",
        };
    }

    function parsePayload(json) {
        var serverDefault = defaultBillingFromJson(json);
        if (json.billing && json.billing.resetUserChoice === true) {
            try {
                localStorage.removeItem(OVERRIDE_KEY);
                localStorage.removeItem(LEGACY_BILLING_KEY);
            } catch (e) {}
        }
        var userPick = getUserBillingOverride();
        var billing = userPick || serverDefault;
        var tiers = Array.isArray(json.tiers)
            ? json.tiers.map(normalizeTier)
            : [];
        return {
            heading: json.heading != null ? String(json.heading) : "",
            subheading: json.subheading != null ? String(json.subheading) : "",
            billing: billing,
            tiers: tiers,
            pricingCta: normalizePageCta(json.pricingCta),
        };
    }

    function renderError(message, retryFetch) {
        clear(inner);
        root.classList.add("is-error");
        root.classList.remove("is-loading", "is-ready");

        var box = document.createElement("div");
        box.className = "streqo-pricing__notice streqo-pricing__notice--error";
        textNode(box, "p", "streqo-pricing__notice-title", message);

        if (typeof retryFetch === "function") {
            var btn = document.createElement("button");
            btn.type = "button";
            btn.className = "streqo-pricing__retry";
            btn.textContent = "Try again";
            btn.addEventListener("click", function () {
                retryFetch();
            });
            box.appendChild(btn);
        }
        inner.appendChild(box);
    }

    function renderMissingConfig() {
        renderError(
            "No pricing JSON URL is available. Add a Pricing API URL in " +
                "Ghost → Settings → Design, or ensure " +
                "assets/pricing-api.example.json is present in the theme.",
            null,
        );
    }

    function buildToolbar(state, onChange) {
        var wrap = document.createElement("div");
        wrap.className = "streqo-pricing__toolbar";

        var intro = document.createElement("div");
        intro.className = "streqo-pricing__intro";
        if (state.heading) {
            textNode(intro, "h2", "streqo-pricing__heading", state.heading);
        }
        if (state.subheading) {
            textNode(
                intro,
                "p",
                "streqo-pricing__subheading",
                state.subheading,
            );
        }
        wrap.appendChild(intro);

        var toggleWrap = document.createElement("div");
        toggleWrap.className = "streqo-pricing__billing";
        toggleWrap.setAttribute("role", "group");
        toggleWrap.setAttribute("aria-label", "Billing period");

        var labelM = document.createElement("button");
        labelM.type = "button";
        labelM.className = "streqo-pricing__billing-btn";
        labelM.setAttribute("data-billing", "monthly");
        labelM.textContent = "Monthly";

        var labelY = document.createElement("button");
        labelY.type = "button";
        labelY.className = "streqo-pricing__billing-btn";
        labelY.setAttribute("data-billing", "yearly");
        labelY.textContent = "Yearly";

        function syncButtons() {
            var isYear = state.billing === "yearly";
            labelM.classList.toggle("is-active", !isYear);
            labelM.setAttribute("aria-pressed", isYear ? "false" : "true");
            labelY.classList.toggle("is-active", isYear);
            labelY.setAttribute("aria-pressed", isYear ? "true" : "false");
        }

        function setBilling(next) {
            if (state.billing === next) return;
            state.billing = next;
            setUserBillingOverride(next);
            syncButtons();
            onChange();
        }

        labelM.addEventListener("click", function () {
            setBilling("monthly");
        });
        labelY.addEventListener("click", function () {
            setBilling("yearly");
        });

        syncButtons();
        toggleWrap.appendChild(labelM);
        toggleWrap.appendChild(labelY);
        if (anyTierHasPricedSlot(state.tiers)) {
            wrap.appendChild(toggleWrap);
        }

        return wrap;
    }

    function renderPriceBlock(card, tier, billing) {
        var prices = tier.prices;
        if (!prices || typeof prices !== "object") return;
        var p = billing === "yearly" ? prices.yearly : prices.monthly;
        if (!p || typeof p !== "object") return;
        if (!hasRenderablePriceAmount(p.formatted)) return;

        var priceBox = document.createElement("div");
        priceBox.className = "streqo-pricing__price";
        var y = tier.prices.yearly || {};
        var floatText =
            billing === "yearly" &&
            y.savingsBadge &&
            String(y.savingsBadge).trim()
                ? String(y.savingsBadge).trim()
                : "";

        var main = document.createElement("div");
        main.className = "streqo-pricing__price-main";

        var line = document.createElement("div");
        line.className = "streqo-pricing__price-line";
        textNode(line, "span", "streqo-pricing__price-amount", p.formatted);

        var amtForSuffix = String(p.formatted != null ? p.formatted : "");
        var suf = trimStr(p.suffix);
        if (suf && amountSuggestsBillingSuffix(amtForSuffix)) {
            var suffixGroup = document.createElement("span");
            suffixGroup.className = "streqo-pricing__price-suffix-group";
            textNode(
                suffixGroup,
                "span",
                "streqo-pricing__price-suffix",
                p.suffix,
            );
            line.appendChild(suffixGroup);
        }

        main.appendChild(line);

        if (floatText) {
            main.classList.add("streqo-pricing__price-main--has-promo-float");
            var flo = document.createElement("span");
            flo.className = "streqo-pricing__year-promo-float";
            flo.textContent = floatText;
            flo.setAttribute("aria-label", "Yearly offer: " + floatText);
            main.appendChild(flo);
        }

        priceBox.appendChild(main);

        var equivFmt =
            p.equivalentFormatted != null
                ? String(p.equivalentFormatted).trim()
                : "";
        if (equivFmt && amountSuggestsBillingSuffix(amtForSuffix)) {
            var eq = document.createElement("p");
            eq.className = "streqo-pricing__price-equiv";
            var suf =
                p.equivalentSuffix != null ? String(p.equivalentSuffix) : "";
            eq.textContent = suf ? equivFmt + " · " + suf : equivFmt;
            priceBox.appendChild(eq);
        }

        card.appendChild(priceBox);
    }

    function renderCard(tier, billing) {
        var card = document.createElement("article");
        card.className = "streqo-pricing__card";
        card.setAttribute("data-tier-id", tier.id);
        if (tier.highlight) card.classList.add("is-highlight");
        if (tier.promo && tier.promo.ring) {
            card.classList.add("is-promo");
        }
        if (!hasDisplayablePrice(tier, billing)) {
            card.setAttribute("data-streqo-no-price", "true");
        }

        if (tier.badge) {
            textNode(card, "span", "streqo-pricing__badge", tier.badge);
        }

        if (tier.promo && tier.promo.ring && tier.promo.label) {
            var promoChip = document.createElement("span");
            promoChip.className = "streqo-pricing__promo-chip";
            promoChip.textContent = tier.promo.label;
            card.appendChild(promoChip);
        }

        textNode(card, "h3", "streqo-pricing__tier-name", tier.name);
        if (tier.description) {
            textNode(card, "p", "streqo-pricing__tier-desc", tier.description);
        }

        if (tier.promo && tier.promo.ring && tier.promo.endsLine) {
            var promoMeta = document.createElement("p");
            promoMeta.className = "streqo-pricing__promo-ends";
            promoMeta.textContent = tier.promo.endsLine;
            card.appendChild(promoMeta);
        }

        if (hasDisplayablePrice(tier, billing)) {
            renderPriceBlock(card, tier, billing);
        }

        var list = document.createElement("ul");
        list.className = "streqo-pricing__features";
        for (var i = 0; i < tier.features.length; i++) {
            var f = tier.features[i];
            if (!f.text) continue;
            var comingSoon = featureIsComingSoon(f.text);
            var displayText = comingSoon
                ? featureTextWithoutComingSoon(f.text)
                : f.text;
            if (!trimStr(displayText)) continue;
            var li = document.createElement("li");
            li.className =
                "streqo-pricing__feature" +
                (f.included ? "" : " is-excluded") +
                (comingSoon ? " streqo-pricing__feature--coming-soon" : "");
            var icon = document.createElement("span");
            icon.className =
                "streqo-pricing__feature-icon" +
                (comingSoon
                    ? " streqo-pricing__feature-icon--coming-soon"
                    : "");
            icon.setAttribute("aria-hidden", "true");
            if (comingSoon) {
                icon.textContent = "⏳";
            } else {
                icon.textContent = f.included ? "✓" : "—";
            }
            li.appendChild(icon);
            var span = document.createElement("span");
            span.textContent = displayText;
            li.appendChild(span);
            list.appendChild(li);
        }
        card.appendChild(list);

        var a = document.createElement("a");
        a.className =
            "streqo-pricing__cta" +
            (tier.cta.style === "outline"
                ? " streqo-pricing__cta--outline"
                : " streqo-pricing__cta--primary");
        var href = hrefWithBilling(tier.cta.url || "#", billing);
        a.setAttribute("href", href);
        if (href.indexOf("http") === 0) {
            a.setAttribute("rel", "noopener noreferrer");
            a.setAttribute("target", "_blank");
        }
        a.textContent = tier.cta.label;
        card.appendChild(a);

        return card;
    }

    function renderAll(state) {
        clear(inner);
        root.classList.remove("is-loading", "is-error");
        root.classList.add("is-ready");

        var shell = document.createElement("div");
        shell.className = "streqo-pricing__panel";

        function redraw() {
            var existing = shell.querySelector(".streqo-pricing__grid");
            if (existing) existing.parentNode.removeChild(existing);
            var oldFoot = shell.querySelector(".streqo-pricing__page-cta-wrap");
            if (oldFoot) oldFoot.parentNode.removeChild(oldFoot);
            var grid = document.createElement("div");
            grid.className = "streqo-pricing__grid";
            for (var i = 0; i < state.tiers.length; i++) {
                grid.appendChild(renderCard(state.tiers[i], state.billing));
            }
            shell.appendChild(grid);
            if (state.pricingCta && trimStr(state.pricingCta.label)) {
                var wrap = document.createElement("div");
                wrap.className =
                    "streqo-pricing__page-cta-wrap streqo-pricing__page-cta";
                var a = document.createElement("a");
                a.className =
                    "streqo-pricing__cta" +
                    (state.pricingCta.style === "outline"
                        ? " streqo-pricing__cta--outline"
                        : " streqo-pricing__cta--primary");
                var href = hrefWithBilling(
                    state.pricingCta.url || "#",
                    state.billing,
                );
                a.setAttribute("href", href);
                if (href.indexOf("http") === 0) {
                    a.setAttribute("rel", "noopener noreferrer");
                    a.setAttribute("target", "_blank");
                }
                a.textContent = state.pricingCta.label;
                wrap.appendChild(a);
                shell.appendChild(wrap);
            }
        }

        var toolbar = buildToolbar(state, function () {
            redraw();
        });
        shell.appendChild(toolbar);
        redraw();

        inner.appendChild(shell);
    }

    function load() {
        var fetchUrl = resolvePricingFetchUrl();
        if (!fetchUrl) {
            renderMissingConfig();
            return;
        }

        var storageKey = cacheKeyPrefix + "|" + fetchUrl;

        root.classList.add("is-loading");
        root.classList.remove("is-ready", "is-error");

        var cached = readCache(storageKey);
        if (cached) {
            try {
                var state = parsePayload(cached);
                renderAll(state);
            } catch (e) {
                clear(inner);
            }
        }

        fetch(fetchUrl, {
            method: "GET",
            credentials: "omit",
            headers: { Accept: "application/json" },
        })
            .then(function (res) {
                if (!res.ok) {
                    throw new Error("HTTP " + res.status);
                }
                return res.json();
            })
            .then(function (json) {
                writeCache(storageKey, json);
                var state = parsePayload(json);
                if (!state.tiers.length) {
                    throw new Error("No tiers in response");
                }
                renderAll(state);
            })
            .catch(function () {
                if (!root.classList.contains("is-ready")) {
                    renderError("We could not load pricing right now.", load);
                }
            });
    }

    load();
})();
